import React from 'react';
import PropTypes from "prop-types";
import {isNotBlank} from "../../../util/StringUtil";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";
import UserDataService from "../../common/UserDataService";
import LoginContactInfoInputComponent from "../input/LoginContactInfoInputComponent";

/**
 * Temporary component until Thomas is finished with the password component.
 */
class PasswordComponent extends React.Component {

    constructor(props){
        super(props);
        this.setPassword = this.setPassword.bind(this);
        this.setConfirmPassword = this.setConfirmPassword.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    extractData(){
        const {data} = this.props;
        return {password: data.password};
    }

    setPassword(e){
        const {setFormState} = this.props;
        setFormState({property: "password", data: e.target.value, metadata: {valid: true, dirty: true}});
    }

    setConfirmPassword(e){
        const {setFormState} = this.props;
        setFormState({property: "confirmPassword", data: e.target.value, metadata: {valid: true, dirty: true}});
    }

    render(){
        const {data, email, metadata,
            setFormState, userDataInit, userDataService, conditionalFed} = this.props;
        const inputCss = getFormInputCssClass(metadata, "password");
        return (
            <div className="grid">
                <div className="grid__col-md-3 grid__col-sm-12">
                    Login Info
                    {
                        conditionalFed &&
                        <p className={"paragraph--small"}>
                            You will need to use this password to log in to CME Group applications.
                        </p>
                    }
                </div>
                <div className="grid__col-md-9 grid__col-sm-12">
                    <LoginContactInfoInputComponent
                        data={data}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        userDataService={userDataService}
                        hideEmail={true}
                        hideName={true}
                    />
                </div>
            </div>

        );
    }

}

PasswordComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    email: PropTypes.string,
    onExtractData: PropTypes.func,
    conditionalFed: PropTypes.bool
};

export default PasswordComponent;